export default __webpack_public_path__ + "media/vendors/app_store_download-b12eabb2.svg";